export default __webpack_public_path__ + "static/media/a8.924f4bcd.JPG";